import { useState, useEffect } from 'react';
import TextBox from './TextBox';
import StyleControls from './StyleControls';
import './MenuEditor.css';

const MenuEditor = () => {
  const [textBoxes, setTextBoxes] = useState([]);
  const [nextId, setNextId] = useState(1);
  const [selectedBoxId, setSelectedBoxId] = useState(null);

  useEffect(() => {
    // Load saved menu on component mount
    const savedMenu = localStorage.getItem('menuData');
    if (savedMenu) {
      const { boxes, lastId } = JSON.parse(savedMenu);
      setTextBoxes(boxes);
      setNextId(lastId);
    }
  }, []);

  const addTextBox = () => {
    const newTextBox = {
      id: nextId,
      content: 'New Item',
      position: { 
        x: Math.round(50 / 20) * 20, // Snap to grid
        y: Math.round(50 / 20) * 20
      },
      styles: {
        width: '200px',
        height: '100px',
        fontSize: '16px',
        fontFamily: 'Arial',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#000000',
        backgroundColor: '#ffffff',
        padding: '8px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#ddd',
        borderRadius: '4px'
      }
    };
    setTextBoxes([...textBoxes, newTextBox]);
    setNextId(nextId + 1);
    setSelectedBoxId(nextId);
  };

  const updateTextBox = (id, updates) => {
    setTextBoxes(textBoxes.map(box => 
      box.id === id ? { ...box, ...updates } : box
    ));
  };

  const deleteTextBox = (id) => {
    setTextBoxes(textBoxes.filter(box => box.id !== id));
    if (selectedBoxId === id) {
      setSelectedBoxId(null);
    }
  };

  const saveMenu = () => {
    const menuData = {
      boxes: textBoxes,
      lastId: nextId
    };
    localStorage.setItem('menuData', JSON.stringify(menuData));
  };

  const selectedBox = textBoxes.find(box => box.id === selectedBoxId);

  const handleCanvasClick = (e) => {
    // Deselect when clicking the canvas background
    if (e.target.className === 'editor-canvas') {
      setSelectedBoxId(null);
    }
  };

  return (
    <div className="menu-editor">
      <div className="toolbar">
        <button onClick={addTextBox}>Add Text Box</button>
        <button onClick={saveMenu}>Save Menu</button>
      </div>
      {selectedBoxId && (
        <StyleControls
          selectedBox={textBoxes.find(box => box.id === selectedBoxId)}
          onUpdate={updateTextBox}
          onDelete={deleteTextBox}
        />
      )}
      <div className="editor-canvas" onClick={handleCanvasClick}>
        {textBoxes.map(box => (
          <TextBox
            key={box.id}
            {...box}
            onUpdate={updateTextBox}
            onClick={() => setSelectedBoxId(box.id)}
            isSelected={selectedBoxId === box.id}
          />
        ))}
      </div>
    </div>
  );
};

export default MenuEditor; 